"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modifierStyle = exports.Weekday = exports.Navbar = exports.CaptionLabel = void 0;
var _react = _interopRequireDefault(require("react"));
var _IconButton = require("../components/IconButton");
var _BackwardArrow = require("../icons/BackwardArrow");
var _ForwardArrow = require("../icons/ForwardArrow");
var _pittaModules = require("@thingsw/pitta-modules");
var _Fonts = require("../constants/Fonts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var modifierStyle = {
  outside: {
    width: 36,
    hegith: 36,
    padding: 0
  },
  disabled: {
    fontSize: 16,
    opacity: 0.35
  },
  selected: {
    borderRadius: 4
  }
};
exports.modifierStyle = modifierStyle;
var Weekday = function Weekday(t, darkMode) {
  return function (_ref) {
    var _t;
    var weekday = _ref.weekday,
      className = _ref.className,
      localeUtils = _ref.localeUtils,
      locale = _ref.locale;
    var weekdayName = localeUtils.formatWeekdayLong(weekday, locale);
    var styleWeek = _objectSpread(_objectSpread({
      color: darkMode ? _pittaModules.DarkColors.primary['2'] : _pittaModules.LightColors.primary['2']
    }, _Fonts.Fonts.Default.Caption), {}, {
      width: 36,
      height: 21,
      padding: 0,
      fontSize: 14
    });
    var name = (_t = t === null || t === void 0 ? void 0 : t(weekdayName.slice(0, 3))) !== null && _t !== void 0 ? _t : weekdayName.slice(0, 3);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: className,
      title: weekdayName,
      style: styleWeek
    }, name);
  };
};
exports.Weekday = Weekday;
var CaptionLabel = function CaptionLabel(t, darkMode) {
  return function (_ref2) {
    var _t2;
    var date = _ref2.date,
      localeUtils = _ref2.localeUtils;
    var months = localeUtils.getMonths();
    var styleCaption = {
      minWidth: 97,
      height: 24,
      padding: 0,
      color: darkMode ? _pittaModules.DarkColors.primary['1'] : _pittaModules.LightColors.primary['1'],
      fontSize: 16
    };
    var monthName = (_t2 = t === null || t === void 0 ? void 0 : t(months[date.getMonth()])) !== null && _t2 !== void 0 ? _t2 : months[date.getMonth()];
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "DayPicker-Caption",
      style: styleCaption
    }, "".concat(monthName, " ").concat(date.getFullYear()));
  };
};
exports.CaptionLabel = CaptionLabel;
var Navbar = function Navbar(props) {
  var onPreviousClick = props.onPreviousClick,
    onNextClick = props.onNextClick,
    className = props.className,
    showNextButton = props.showNextButton;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
    style: {
      position: 'absolute',
      top: 16,
      left: 16,
      marginBottom: 13,
      padding: 0,
      float: 'left'
    },
    onClick: function onClick() {
      return onPreviousClick === null || onPreviousClick === void 0 ? void 0 : onPreviousClick();
    }
  }, /*#__PURE__*/_react.default.createElement(_BackwardArrow.BackwardArrow, null)), /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
    style: _objectSpread({
      position: 'absolute',
      top: 16,
      right: 16,
      marginBottom: 13,
      float: 'right',
      color: _pittaModules.LightColors.primary['3']
    }, showNextButton ? {} : {
      opacity: 0.35
    }),
    disabled: !showNextButton,
    onClick: function onClick() {
      return onNextClick === null || onNextClick === void 0 ? void 0 : onNextClick();
    }
  }, /*#__PURE__*/_react.default.createElement(_ForwardArrow.ForwardArrow, null)));
};
exports.Navbar = Navbar;